import {management} from '../../../index.js' //api
import {Et0Repository} from '../../infra/knex/repositories/et0'
import {SaveEtoUseCase} from "./saveET0"
// const {SaveEt0Controller}=require("./saveEt0Controller")

// module.exports=()=>{
//     const useCase=new SaveEtoUseCase(new Et0Repository(management))
//     const controller=new SaveEt0Controller(useCase)
//     return controller
// }

export const saveEt0UseCase=new SaveEtoUseCase(new Et0Repository(management))
